/** @format */
/**
 * CustomSpanProcessor functionality will be moved to Utag, leave it for now as a reference
 */
import { ReadableSpan, Span, SpanProcessor } from '@opentelemetry/sdk-trace-base';

import { Context } from '@opentelemetry/api';

export class CustomSpanProcessor implements SpanProcessor {
  private attributes: Record<string, string> | null;
  constructor(attributes: Record<string, string> | null) {
    this.attributes = attributes;
  }

  forceFlush(): Promise<void> {
    return Promise.resolve();
  }

  onStart(span: Span, parentContext: Context): void {
    if (this.attributes) {
      Object.entries(this.attributes as object).forEach(([key, value]) => {
        if (value) {
          span.setAttribute(key, value);
        }
      });
    }
  }

  onEnd(span: ReadableSpan): void {
    //
  }

  shutdown(): Promise<void> {
    return Promise.resolve();
  }

  // Use this method if you want to pass attributes after initializing the SpanProcessor
  setProvider(attributes: Record<string, string> | null): void {
    this.attributes = attributes;
  }
}
